import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import Leaflet from 'leaflet';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
function ChangeView({ center, zoom }) {
    const map = useMap();
    map.setView(center, zoom);
    map.invalidateSize();
    return null;
}

Leaflet.Icon.Default.imagePath =
    '../node_modules/leaflet'

delete Leaflet.Icon.Default.prototype._getIconUrl;

Leaflet.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

function MapTracker() {

    let state = useLocation();

    console.log("state", state?.state?.trackingId)

    const [coordinates, setCoordinates] = useState({ latitude: "", longitude: "" });

    const showPosition = (position) => {
        console.log("Latitude: " + position.coords.latitude + "<br>Longitude: " + position.coords.longitude);
        setCoordinates({ latitude: position.coords.latitude, longitude: position.coords.longitude });
    }

    const getVehicleLocation = () => {
        axios.get(`https://ng.mobiliz.com.tr/su3/api/integrations/locations?muId=${state?.state?.trackingId}`,
            {
                headers: {
                    "Mobiliz-Token": "8823d3eebf72ae19f13a8de35fd22639b7ea03a4f30844db3b38d63b7307c3ff"
                }
            }
        )
            .then((response) => {
                console.log(response.data)
                setCoordinates({ latitude: response.data.result[0].latitude, longitude: response.data.result[0].longitude });
            })
            .catch((error) => {
                console.error(error)
            })
    }

    useEffect(() => {
        getVehicleLocation()
    }, [])

    const center = [coordinates.latitude, coordinates.longitude];
    const zoom = 15;

    return (
        <MapContainer center={center} zoom={zoom} scrollWheelZoom={true} style={{ height: "95vh", width: "100%" }}>
            <ChangeView center={center} zoom={zoom} />
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            />
            <Marker position={center} style={{ color: "red" }}>
                <Popup>
                    {state?.state?.plate} Plakalı Araç Konumu
                </Popup>
            </Marker>
        </MapContainer>
    );
}

export default MapTracker;